import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { Features } from '@ynap/feature-selector';
import sizeChartLinkShouldDisplay from './sizeChartLinkShouldDisplay';

const bem = new BEMHelper('SizeChartLink');

const SizeChartLinkFeatureWrapper = (props) => (
    <Features>
        <SizeChartLink {...props} />
    </Features>
);
const SizeChartLink = ({
    features,
    className,
    isOneSize,
    sizeConversion,
    sizeMeasurement = {},
    setSizeChartModal,
    dataTestId,
    children,
    hasMeaningfulSize,
    placeModifier,
}) => {
    const sizeChartClassName = `${bem()} ${bem('sizeGuide', placeModifier)} ${className}`;

    if (sizeChartLinkShouldDisplay(features, sizeConversion, isOneSize, sizeMeasurement, hasMeaningfulSize)) {
        return (
            <div data-testid={dataTestId} className={sizeChartClassName}>
                <a className={bem('sizeGuideLink')} href="#" onClick={setSizeChartModal}>
                    <div>{children}</div>
                </a>
            </div>
        );
    }
    return null;
};

const BasePropTypes = {
    className: PropTypes.string,
    sizeMeasurement: PropTypes.array,
    sizeConversion: PropTypes.array,
    setSizeChartModal: PropTypes.func,
    messages: PropTypes.object,
    dataTestId: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    isOneSize: PropTypes.bool,
    hasMeaningfulSize: PropTypes.bool,
    optimizely: PropTypes.object,
    placeModifier: PropTypes.string,
};

const PropTypesWithFeatures = {
    features: PropTypes.object,
    ...BasePropTypes,
};

SizeChartLinkFeatureWrapper.propTypes = BasePropTypes;
SizeChartLink.propTypes = PropTypesWithFeatures;

export default SizeChartLinkFeatureWrapper;
